import React from 'react'
import { SideMenuListContainer, SideMenuListItem, SideMenuListSeparator } from './Theme'

const SideMenuList = ({
  list,
  selected,
  onClick,
}) => {
  return (
    <SideMenuListContainer className="mt-5">
      {list?.map((item, index) => (
        <SideMenuListItem key={item.value} selected={selected === item.value} onClick={() => onClick(item)}>
          {item.label}
          <SideMenuListSeparator />
        </SideMenuListItem>
      ))}
    </SideMenuListContainer>
  )
}

export default SideMenuList